"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var rand_1 = require("./rand");
var TerrainTypes_1 = require("../TerrainTypes");
function evaluateChance(chance) {
    return chance > rand_1.getRandomInt(0, 1000);
}
exports.evaluateChance = evaluateChance;
function evaluateCircleSpot(cx, cy, r, theta, type) {
    var x = Math.round(cx + (type === TerrainTypes_1.CircleTypes.HorizontalEllipse ? 0.5 * r : r) * Math.cos(theta));
    var y = Math.round(cy - (type === TerrainTypes_1.CircleTypes.VerticalEllipse ? 0.5 * r : r) * Math.sin(theta));
    return {
        x: x, y: y
    };
}
exports.evaluateCircleSpot = evaluateCircleSpot;
function intercept(point, slope) {
    if (slope === null) {
        // vertical line
        return point.x;
    }
    return point.y - slope * point.x;
}
function slope(a, b) {
    if (a.x === b.x) {
        return null;
    }
    return (b.y - a.y) / (b.x - a.x);
}
function drawLineToSpot(map, 
// start
sx, sy, 
// end
ex, ey, type) {
    var start = { x: sx, y: sy };
    var end = { x: ex, y: ey };
    var m = slope(start, end);
    var b = intercept(start, m);
    if (m !== null) {
        for (var x = start.x; x <= end.x; x++) {
            var y = Math.round(m * x + b);
            map.safeWrite(x, y, type);
        }
    }
    else {
        for (var y = start.y; y <= end.y; y++) {
            map.safeWrite(start.x, y, type);
        }
    }
}
exports.drawLineToSpot = drawLineToSpot;
function drawCircle(map, cx, cy, r, terrain, type, fill) {
    var e_1, _a, e_2, _b;
    var spots = [];
    var PI2 = 2 * Math.PI;
    var step = PI2 / 20;
    // draw circle around
    for (var theta = 0; theta < PI2; theta += step) {
        var spot = evaluateCircleSpot(cx, cy, r, theta, type);
        spots.push(spot);
        if (!fill) {
            // write spots
            map.safeWrite(spot.x, spot.y, terrain);
        }
    }
    if (fill) {
        try {
            // connect the dots
            for (var spots_1 = __values(spots), spots_1_1 = spots_1.next(); !spots_1_1.done; spots_1_1 = spots_1.next()) {
                var spot1 = spots_1_1.value;
                try {
                    for (var spots_2 = (e_2 = void 0, __values(spots)), spots_2_1 = spots_2.next(); !spots_2_1.done; spots_2_1 = spots_2.next()) {
                        var spot2 = spots_2_1.value;
                        drawLineToSpot(map, spot1.x, spot1.y, spot2.x, spot2.y, terrain);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (spots_2_1 && !spots_2_1.done && (_b = spots_2.return)) _b.call(spots_2);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (spots_1_1 && !spots_1_1.done && (_a = spots_1.return)) _a.call(spots_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
}
exports.drawCircle = drawCircle;
